// RailSearch — the search input at the top of the SessionsRail.
//
// Per designer Q15 + Q19:
// - A quiet mono-styled input above "+ New session"
// - On focus: brand border + ⌘K hint on the right
// - On keypress: parent-owned query state; empty query returns the grouped rail
// - Esc clears + returns to the grouped rail
// - ↑↓ move through results, Enter opens the highlighted one (SearchResults
//   owns that keyboard handling since it needs to know the result list)
//
// Keeps rendering as a plain input; SearchResults is a sibling that renders
// the results list when `query` is non-empty.

import { useRef } from 'react';
import { useI18n } from '../i18n/index.js';
import styles from './Coach.module.css';

export interface RailSearchProps {
  value: string;
  onChange: (next: string) => void;
  onEscape: () => void;
}

export function RailSearch({ value, onChange, onEscape }: RailSearchProps) {
  const { t } = useI18n();
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={styles.railSearch}>
      <input
        ref={inputRef}
        type="search"
        className={styles.railSearchInput}
        placeholder={t('search.placeholder')}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            e.preventDefault();
            onEscape();
            inputRef.current?.blur();
          }
        }}
      />
      {value.length === 0 && (
        <span className={styles.railSearchHint} aria-hidden="true">
          ⌘K
        </span>
      )}
    </div>
  );
}
